export enum RobotsFormFields {
  CONTENT = 'content',
}

export type TUpdateRobotsFormValues = {
  [RobotsFormFields.CONTENT]: string;
};
